import ActionTypes from '../../../ActionsTypes';
export function setBackground(color) {
  return {
    type: ActionTypes.SET_HEADER_BACKGROUND,
    payload: {
      color: color
    }
  };
}
export function setColor(color) {
  return {
    type: ActionTypes.SET_HEADER_COLOR,
    payload: {
      color: color
    }
  };
}